import React, { useCallback, useEffect } from 'react'
import * as aplitude from '@amplitude/analytics-browser'
import { userInfoSelector } from 'store/selectors/user'
import { useSelector } from 'react-redux'
import { use } from 'i18next'
import { RootStore } from 'store'

export enum AmplitudeEvents {
  CREATE_DEAL = 'Create deal', // +
  VIEW_NGN_DEAL = 'View NGN deal', // +
  VIEW_CAD_DEAL = 'View CAD deal', // +
  VERIFY_NGN_DEAL = 'Verify NGN deal', // +
  VERIFY_CAD_DEAL = 'Verify CAD deal', // +
  BUY_DEAL = 'Buy deal', // +
  VIEW_SETTINGS = 'View settings', // +
  UPDATE_USER_DISPLAY_NAME = 'Update user display name',
  CHANGE_PASSWORD = 'Change password', // +
  RESET_PASSWORD = 'Reset password', // +
  FORGOT_PASSWORD = 'Forgot password', // +
  SIGN_IN = 'Sign in', // +
  SIGN_UP = 'Sign up', // +
  FINISH_TUTORIAL = 'Finish tutorial', // +
  RESET_TUTORIAL = 'Reset tutorial', // +
  GO_FAQ = 'Go FAQ', // +
  CREATE_PAYOUT_ACCOUNT = 'Create payout account', // +
  EDIT_PAYOUT_ACCOUNT = 'Edit payout account', // +
  LOGOUT = 'Logout', // +
  GO_TO_MARKETPLACE = 'Go to marketplace', // +
  ADD_FUNDS = 'Add funds', // +
  WITHDRAW_FUNDS = 'Withdraw funds', // +
  VIEW_DEAL_TRANSACTIONS = 'View deal transactions', // +
  VIEW_WALLET_TRANSACTIONS = 'View wallets transactions', // +
  VIEW_MY_DEALS = 'View my deals', // +
  EDIT_DEAL = 'Edit deal', // +
  DELETE_DEAL = 'Delete deal', // +
}

const AmplitudeContext = /*#__PURE__*/ React.createContext<{
  trackAction?: (event: AmplitudeEvents, data?: any) => void
}>({
  trackAction: undefined,
})

export const AmplitudeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const userInfo = useSelector(userInfoSelector)
  const trackAction = useCallback(
    (event: AmplitudeEvents, data = {}) => {
      aplitude.track({
        event_type: event,
        user_id: userInfo?.id,
        ...data,
      })
    },
    [userInfo],
  )

  useEffect(() => {
    aplitude.init(process.env.REACT_APP_AMPLITUDE_API_KEY || '', undefined, {
      defaultTracking: {
        sessions: true,
        pageViews: true,
        formInteractions: true,
        fileDownloads: true,
      },
    })
  }, [])
  return <AmplitudeContext.Provider value={{ trackAction }}>{children}</AmplitudeContext.Provider>
}

export const useTrackAction = () => {
  const { trackAction } = React.useContext(AmplitudeContext)
  return trackAction
}
